import { TextFieldProps } from "@mui/material";
import { Controller, UseControllerProps } from "react-hook-form";

import { DatePickerField, DatePickerFieldProps } from "@components/DatePickers";

import { LoadingEndAdornment } from "./DynamicAutocomplete";

type OtherProps = {
  formatValue?: string;
  size?: TextFieldProps["size"];
  loading?: boolean;
};

export type DatePickerInputProps = UseControllerProps<any> &
  DatePickerFieldProps &
  OtherProps;

const DatePickerInput = (props: DatePickerInputProps) => {
  const { control, name, formatValue, label, size, loading, sx, ...rest } = props;

  const inputAdornment = {
    component: loading
      ? () => <LoadingEndAdornment loading={!!loading} />
      : undefined,
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, value, ...restField },
        fieldState,
      }) => {
        return (
          <DatePickerField
            value={value}
            onChange={(value) =>
              formatValue ? onChange(value?.format(formatValue)) : value
            }
            slotProps={{
              inputAdornment,
              textField: {
                label: label || "Date",
                fullWidth: true,
                error: !!fieldState.error,
                sx: {
                  ".MuiSvgIcon-root": { fontSize: 20 },
                  ...sx,
                },
              },
            }}
            {...restField}
            {...rest}
          />
        );
      }}
    />
  );
};

export default DatePickerInput;
